import {HTML_IDS} from './constants.js'

// Const GAME_TARGET_ID = process.env.GAME_I_FRAME_ID
export const GAME_TARGET_ID = `game`
let gameWidth = `100%`
let adPlaceholder

const addBannerDiv = async (adSlotSettings) => {
    const {width, height} = adSlotSettings.placeholderSize
    gameWidth = `calc(100% - ${width}px)`
    const gameIFrame = document.querySelector(`#${GAME_TARGET_ID}`)
    gameIFrame.style.width = gameWidth // Set width for the game

    if (!document.querySelector(`#${HTML_IDS.AD_CONTAINER}`)) {
        const adDiv = document.createElement('div')
        adDiv.setAttribute('id', HTML_IDS.AD_CONTAINER)
        adDiv.setAttribute(
            'style',
            `width: 160px; height: 600px; display: inline-block; min-width: 160px; min-height: 600px; position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);`
        )

        adPlaceholder = document.createElement('div')
        adPlaceholder.setAttribute('id', HTML_IDS.AD_PLACEHOLDER)
        adPlaceholder.setAttribute(
            'style',
            `width: ${width}px; height: ${height}; background: #ffffff; position: absolute; right: 0px; top: 0px; display: inline-block; min-width: 170px; min-height: 610px;`
        )
        adPlaceholder.append(adDiv)

        document.body.append(adPlaceholder)
    }
}

const getGameMinWidth = () =>
    Number.parseInt(
        document.querySelector(`#${GAME_TARGET_ID}`).style.minWidth,
        10
    ) || 800

const hideAd = () => {
    adPlaceholder.remove()
}

const showAd = () => {
    document.body.append(adPlaceholder)
}

export {addBannerDiv, getGameMinWidth, hideAd, showAd}
